import NInline from './NInline.vue';

export default NInline;